import React, { useState } from 'react';

interface BoundingBoxImageProps {
    imageUrl: string;
    minx: number;
    miny: number;
    maxx: number;
    maxy: number;
    width?: number | string;
}

// The box coordinates are full-resolution pixels, so they are placed as percentages
// of the image's natural size and stay correct however the image is rendered.
const BoundingBoxImage = ({ imageUrl, minx, miny, maxx, maxy, width = 256 }: BoundingBoxImageProps) => {
    const [natural, setNatural] = useState<{ w: number; h: number } | null>(null);

    const boxStyle: React.CSSProperties | undefined = natural ? {
        position: 'absolute',
        left: (minx / natural.w) * 100 + '%',
        top: (miny / natural.h) * 100 + '%',
        width: ((maxx + 1 - minx) / natural.w) * 100 + '%',
        height: ((maxy + 1 - miny) / natural.h) * 100 + '%',
        border: '1px solid #0F0',
        pointerEvents: 'none',
        boxSizing: 'border-box',
    } : undefined;

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            <img
                src={imageUrl}
                alt=""
                width={width}
                // Block, not the default inline: an inline image leaves a baseline gap that makes the
                // relative container taller than the picture, so the box's percentage `top` — measured
                // against the container — lands a few pixels low. Block makes the container match the image.
                style={{ display: 'block' }}
                onLoad={(e) => setNatural({ w: e.currentTarget.naturalWidth, h: e.currentTarget.naturalHeight })}
            />
            {boxStyle && <div style={boxStyle}></div>}
        </div>
    );
};

export default BoundingBoxImage;
